const DashboardPage = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">
        Bienvenue sur le tableau de bord
      </h1>
      <p className="text-gray-600">
        Cette section est en cours de construction.
      </p>
    </div>
  );
};

export default DashboardPage;
